program InkaDeltagare;



{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  InkaDeltagareMainForm in 'InkaDeltagareMainForm.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.Run;
end.
